import React, { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import Icon from '@common/assets';
import JobGroupModal from '@components/jobs/filterLayer/jobGroupModal';
import { CalendarJobTitleDto } from '@domain/rs/calendar/CalendarUserFilterRs';

import classnames from 'classnames/bind';
import styles from './jobGroupArea.module.scss';
const cx = classnames.bind(styles);

interface JobGroupAreaProps {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  prefix: string;
}

const JobGroupArea: FC<JobGroupAreaProps> = ({ isVisible, setIsVisible, prefix }) => {
  const { getValues } = useFormContext();
  const { field: jobTitlesField } = useController({
    name: prefix,
  });

  //jobTitlesField가 input에 등록되어있지 않기 때문에(jobTitlesField.value = undefined), getValues를 통해 값을 가져와야한다.
  const jobTitlesValue = getValues(prefix) ?? [];
  const chipEl = jobTitlesValue.map((item: CalendarJobTitleDto) => {
    const onDeleteJobTitle = () => {
      const filterdList = jobTitlesValue.filter((el: CalendarJobTitleDto) => el.code !== item.code);
      jobTitlesField.onChange(filterdList);
    };

    return (
      <div className={cx('jobGroupChipInner')} key={item.code}>
        <div className={cx('jobGroupChipWrap')}>
          <div className={cx('jobGroupChip')}>
            <div className={cx('jobGroupText')}>{item.name}</div>
            <a className="btnDelete" role="button" onClick={onDeleteJobTitle}>
              <Icon name="closeLight" width={16} height={16} />
            </a>
          </div>
        </div>
      </div>
    );
  });

  return (
    <div className={cx('filterWrap')}>
      <div className={cx('filterTitleArea')}>
        <em className={cx('filterTitle')}>직군 · 직무</em>
        <div className={cx('btnFilterArea')}>
          <a className={cx('btnFilter')} role="button" onClick={() => setIsVisible(true)}>
            <Icon name="addLight" width={24} height={24} />
          </a>
        </div>
      </div>
      <div className={cx('jobGroupChipArea', { empty: !chipEl.length })}>
        {/* 칩 영역 */}
        {chipEl}
      </div>

      {/* 직군직무 필터 모달 영역 */}
      <JobGroupModal visible={isVisible} onClose={() => setIsVisible(false)} />
    </div>
  );
};

export default JobGroupArea;
